/**
 * Application metadata configuration.
 * Contains static information about the app for branding and versioning.
 */
export default {
  title: "ΟpenΟps",
  version: "1.1.0"
};
